export function getId() {
    return String((new Date()).getTime()) + String(Math.floor(Math.random() * 10));
}